var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgScroll3 = function SvgScroll3(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "scroll_3_svg__scroll",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 232 400.4615",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_3_svg__radial-gradient",
    cx: 1.5448,
    cy: 20.2888,
    r: 469.8113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#07d887"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6478,
    stopColor: "#35a08e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a8791"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_3_svg__radial-gradient-2",
    cx: -31.5321,
    cy: 257.0018,
    r: 215.5438,
    xlinkHref: "#scroll_3_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_3_svg__radial-gradient-3",
    cx: 73.2857,
    cy: 232.6044,
    r: 205.5282,
    xlinkHref: "#scroll_3_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_3_svg__radial-gradient-4",
    cx: 137.5,
    cy: 273.7123,
    r: 118.1565,
    xlinkHref: "#scroll_3_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_3_svg__radial-gradient-5",
    cx: 79.0543,
    cy: 163.1558,
    r: 278.2346,
    xlinkHref: "#scroll_3_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_3_svg__radial-gradient-6",
    cx: 31.98,
    cy: 144.0072,
    r: 373.0061,
    xlinkHref: "#scroll_3_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_3_svg__radial-gradient-7",
    cx: 118.5461,
    cy: 126.0049,
    r: 214.8636,
    xlinkHref: "#scroll_3_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_3_svg__radial-gradient-8",
    cx: 146.8681,
    cy: 134.2308,
    r: 197.4594,
    xlinkHref: "#scroll_3_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_3_svg__radial-gradient-9",
    cx: 82.3988,
    cy: 40.447,
    r: 386.3936,
    xlinkHref: "#scroll_3_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_3_svg__radial-gradient-10",
    cx: -49.2146,
    cy: -40.0748,
    r: 580.5636,
    xlinkHref: "#scroll_3_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_3_svg__radial-gradient-11",
    cx: 18.7842,
    cy: 77.4455,
    r: 148.9581,
    gradientTransform: "translate(-5.7546 5.6158) rotate(-1.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffff40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0381,
    stopColor: "#f6fe44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8ff171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8452,
    stopColor: "#4de88e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34e599"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_3_svg__radial-gradient-12",
    cx: 169.022,
    cy: 298.1189,
    r: 203.9856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b897"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#25c698"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7646,
    stopColor: "#66df9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7fe99b"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_3_svg__radial-gradient-13",
    cx: 262.6439,
    cy: 252.3219,
    r: 300.5038,
    gradientTransform: "translate(-5.7546 5.6158) rotate(-1.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2712,
    stopColor: "#26c4a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7662,
    stopColor: "#67de9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80e899"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_3_svg__radial-gradient-14",
    cx: 222.6525,
    cy: 389.496,
    r: 243.959,
    gradientTransform: "translate(-5.7546 5.6158) rotate(-1.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0194,
    stopColor: "#02b5bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6858,
    stopColor: "#43bb95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5cbd85"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_3_svg__radial-gradient-15",
    cx: 102.4335,
    cy: 230.1666,
    r: 159.0826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6ae8c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6fb57f"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_3_svg__radial-gradient-16",
    cx: 176.6436,
    cy: 401.2529,
    r: 161.0665,
    gradientTransform: "translate(-5.7546 5.6158) rotate(-1.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#168492"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6627,
    stopColor: "#52bb9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6bd2a3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_3_svg__radial-gradient-17",
    cx: 129.8791,
    cy: 274.5571,
    r: 129.7146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2cc29a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3545,
    stopColor: "#37bea1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48b7ac"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_3_svg__radial-gradient-18",
    cx: 318.0044,
    cy: 256.5717,
    r: 211.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a07f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2554,
    stopColor: "#23b28e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7612,
    stopColor: "#64d4a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7de1b4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_3_svg__radial-gradient-19",
    cx: 174.033,
    cy: 316.4725,
    r: 373.2329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6ae8ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6fb57f"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_3_svg__radial-gradient-20",
    cx: 66.7245,
    cy: 10.3162,
    r: 82.0429,
    gradientTransform: "translate(-5.7546 5.6158) rotate(-1.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5826,
    stopColor: "#2ad7b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43ebab"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_3_svg__radial-gradient-21",
    cx: 174.2269,
    cy: 330.6007,
    r: 50.6516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5ab48b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54bac4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "scroll_3_svg__left"
  }, /*#__PURE__*/React.createElement("g", {
    id: "scroll_3_svg__inner"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115,0l58,79q16,36.7308,32,73.4615,3.5,19.5,7,39,.5,27,1,54,9.5,36,19,72Q228.5,341.2308,225,365l-19,35.4615L100,372,26,287l32-54.5385Z",
    style: {
      fill: "url(#scroll_3_svg__radial-gradient)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "scroll_3_svg__shapes"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100,372q3.5-10.5,7-21L27,289Z",
    style: {
      fill: "url(#scroll_3_svg__radial-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107,351l83,11q8,19,16,38L100,372Q103.5,361.5,107,351Z",
    style: {
      fill: "url(#scroll_3_svg__radial-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,346l25,18-19,36q-8-19-16-38Z",
    style: {
      fill: "url(#scroll_3_svg__radial-gradient-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211,305l21,12q-3.5,24-7,48l-25-19Z",
    style: {
      fill: "url(#scroll_3_svg__radial-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,231l17,15q9.5,36,19,72l-21-13Z",
    style: {
      fill: "url(#scroll_3_svg__radial-gradient-6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,186l12,5q.5,27.5,1,55l-17-16Q198,208,200,186Z",
    style: {
      fill: "url(#scroll_3_svg__radial-gradient-7)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,155l10-2q3.5,18.5,7,37l-12-3Q197.5,171,195,155Z",
    style: {
      fill: "url(#scroll_3_svg__radial-gradient-8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,79l32,74-10,2Z",
    style: {
      fill: "url(#scroll_3_svg__radial-gradient-9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,0l6,17,52,62Z",
    style: {
      fill: "url(#scroll_3_svg__radial-gradient-10)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "scroll_3_svg___Layer_",
    "data-name": "<Layer>"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121,17q.5,10.5,1,21,8.5,40,17,80l32-30q1-4.5,2-9Z",
    style: {
      fill: "url(#scroll_3_svg__radial-gradient-11)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,79q11,38.2308,22,76.4615,2.5,15,5,30Q198,208.2308,196,231l-3-2-39-52-14.2986-61.764Z",
    style: {
      fill: "url(#scroll_3_svg__radial-gradient-12)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,180q-8.244,22.3005-17,45-11.3989,29.537-23,58L7,243l-7-4L121,17Q138.5,98.5,156,180Z",
    style: {
      fill: "url(#scroll_3_svg__radial-gradient-13)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,289,0,239l115.5,41.8634L116,286l-6,58-3,7Z",
    style: {
      fill: "url(#scroll_3_svg__radial-gradient-14)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.6034,268.3932,161,240l50,65Z",
    style: {
      fill: "url(#scroll_3_svg__radial-gradient-15)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,281q-4,35-8,70l15-5,81-35,8-6-63-37Z",
    style: {
      fill: "url(#scroll_3_svg__radial-gradient-16)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211,305,107,351l58,8,35-13Z",
    style: {
      fill: "url(#scroll_3_svg__radial-gradient-17)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,240l-6-58q.5-3,1-6l41,55,15,74Z",
    style: {
      fill: "url(#scroll_3_svg__radial-gradient-18)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155,176q-9.33,25.1091-18.7693,50.1821Q125.9278,253.5505,115.5,280.8634L147,268l14.2166-26.6715Z",
    style: {
      fill: "url(#scroll_3_svg__radial-gradient-19)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79,94l42-77L115,0Z",
    style: {
      fill: "url(#scroll_3_svg__radial-gradient-20)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,359l35-13-10,16Z",
    style: {
      fill: "url(#scroll_3_svg__radial-gradient-21)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "scroll_3_svg__highlights_copy_3",
    "data-name": "highlights copy 3",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156,176l3,42q-2-20-4-40l-13,33,12-35q-9.4764-46.8942-9-47Q145.4794,128.898,156,176Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,279l-32-9,30,12q-1,12.5-2,25,2.5-12.5,5-25l31-13,9-19-10,18Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,199,4,238l57,23L4,242l19,39L0,239Z",
    style: {
      fill: "#f2f2f2"
    }
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgScroll3);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/scroll_3.d33032541fcd1d8bd30fd74ad2d0e47d.svg";